import { ModelDataInputs, SimStateByH3R4Id, SimulationState, StateAtTimepoint } from "../sim_3d/model/v3/interface"
import pub_sub from "../sim_3d/state/pub_sub"
import { AppStore } from "../state/store"


interface PerformantAppStateAccessor
{
    data_dependencies: ModelDataInputs

    step1: StateAtTimepoint | undefined
    step2: StateAtTimepoint | undefined
    step_mix: number

    sim_state_by_h3r4: SimStateByH3R4Id
    built_power_plants: SimulationState["built_power_plants"] | undefined
}
const performant_accessor: PerformantAppStateAccessor = {
    data_dependencies: {} as ModelDataInputs,

    step1: undefined,
    step2: undefined,
    step_mix: 0,

    sim_state_by_h3r4: {},
    built_power_plants: undefined,
}
export function setup_performant_accessor(app_store: AppStore, data_dependencies: ModelDataInputs)
{
    performant_accessor.data_dependencies = data_dependencies

    const ref: {
        timesteps: StateAtTimepoint[]
    } = { timesteps: [] }

    app_store.subscribe((state, previous_state) =>
    {
        if (previous_state.simulation_state.sim_state?.timesteps !==
                     state.simulation_state.sim_state?.timesteps)
        {
            ref.timesteps = state.simulation_state.sim_state?.timesteps ?? []
        }

        if (previous_state.simulation_state.sim_state?.built_power_plants !==
                     state.simulation_state.sim_state?.built_power_plants)
        {
            performant_accessor.built_power_plants = state.simulation_state.sim_state?.built_power_plants
        }
    })

    pub_sub.sub("simulation_datetime", payload =>
    {
        performant_accessor.step1 = ref.timesteps[payload.datetime_sim_range_hourly_indices_mix.one]
        performant_accessor.step2 = ref.timesteps[payload.datetime_sim_range_hourly_indices_mix.two]
        performant_accessor.step_mix = payload.datetime_sim_range_hourly_indices_mix.mix
    })

    pub_sub.sub("simulation_datetime_step", payload =>
    {
        performant_accessor.sim_state_by_h3r4 = ref.timesteps[payload.datetime_sim_range_hourly_index]?.by_h3r4 ?? {}
    })
}

export function get_performant_state_reference()
{
    return performant_accessor
}
